import axios from 'axios';
import swal from 'sweetalert';

import { Config } from './Config';

var configData = Config();
const axiosInstance = axios.create(configData);

// axiosInstance.interceptors.response.use(
axiosInstance.interceptors.response.use(
    response => response,
    error => {
        if (error?.response?.status === 401) {
            window.location.href = "/admission/#/login";
            localStorage.removeItem('user');
            localStorage.removeItem('access');
            localStorage.removeItem('pimg');
            // swal("", "Session Expired", "error", { button: "Ok!", })
            //     .then(ok => {
            //         localStorage.removeItem('user');
            //         localStorage.removeItem('access');
            //         return window.location.href = '/'
            //     })
        }
        if (error?.response?.status === 426) swal("", "Your license has been expired. Contact site administrator", "error", { button: "Ok!", })
        return Promise.reject(error);
    }
);
export default axiosInstance;
